import { Box, useMediaQuery } from '@chakra-ui/react';
import { FooterDesktop } from './FooterDesktop';
import { FooterMobile } from './FooterMobile';
import { BG, LINK } from './footerStyles';

export const Footer = () => {
  const [isMdUp] = useMediaQuery('(min-width: 768px)');

  return (
    <Box as='footer' bg={BG} color={LINK} w='100%' px='20px' py={{ base: 10, md: 14 }} dir='rtl'>
      {isMdUp ? <FooterDesktop /> : <FooterMobile />}
    </Box>
  );
};
